import debug from 'debug';

export default function createLogger(name) {
  var logger = debug(name);

  return function (message) {
    logger(message);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/util-logger/es/createLogger.js
// module id = 1075
// module chunks = 1